// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__141zK","label":"Completed_label__3tfLR"};